import { element_exists, redesignDataTablesHeader } from "../functions";
import {
  addSelectedCompanyHandler,
  fnErrorMsg,
  fnToastrFormError,
  pjaxRedirect,
  printResponse,
  resetForm,
} from "../jquery-functions-library";
import moment from "moment";
import AutoNumeric from "autonumeric";
import { info } from "toastr";

function getSummary(payrollId) {
  $.ajax({
    url: "/salary/payrolls/summary/" + payrollId,
    success: function(response) {
      $(".summary").html(response);
    },
    error: fnErrorMsg,
  });
}

export var fnPayrollDataTable = function() {
  const selectedPayrollId = $("#selected_payroll").attr("value");
  const tableId = "#datatable-payroll";
  const $table = $(tableId);

  /**
   * Find all table headers with a data-editable-column attribute, and then convert the list of headers to an array of objects that represent editable columns.
   * Each object has a data property, which is the name of the data column, and a render function that renders the editable column as an HTML input element.
   */
  const editableColumns = $table
    .find($("th[data-editable-column]"))
    .toArray()
    .map((col) => {
      const columnId = $(col).data("editable-column");
      const payrollFieldId = $(col).data("editable-column-payroll-id");
      return {
        data: columnId.replace(":", "_"),
        render(data, type, row) {
          if (type !== "display") {
            return data === null ? 0 : data;
          }

          const splitColumnId = columnId.split(":");
          if (typeof row.activatedColumns[splitColumnId[0]] === "undefined") {
            return "";
          } else {
            if (
              !Boolean(row.activatedColumns[splitColumnId[0]][splitColumnId[1]])
            ) {
              return "";
            }
          }

          const classes = ["payroll-input"];

          if (data !== null) {
            classes.push("payroll-input--filled");
          }

          const valueAttr = data !== null ? `value="${data}"` : "";

          const readOnlyAttr = row[`${columnId.replace(":", "_")}_read_only`]
            ? 'disabled="disabled"'
            : "";

          return `
            <input
                type="text"
                id="payrollInput-${columnId.replace(":", "_")}-${row.id}"
                class="${classes.join(" ")}"
                data-employee-id="${row.id}"
                data-field-id="${columnId}"
                data-payroll-field-id="${payrollFieldId}"
                ${valueAttr}
                ${readOnlyAttr}
            />

            <span style="position: absolute; opacity:0;">
                ${data !== null ? thousandSeparator(data) : ""}
            </span>
         `;
        },
      };
    });

  if (!element_exists(tableId) || $.fn.dataTable.isDataTable(tableId))
    return false;

  $.ajaxSetup({ headers: { "X-CSRF-TOKEN": $('[name="_token"]').val() } });

  //set variable checking if button with id btn-unlock-payroll is present on page (only present on payroll page)
  let btnUnlockPayroll = document.getElementById("btn-unlock-payroll");
  let payrollIsSentForApproval = false;
  if (btnUnlockPayroll) {
    payrollIsSentForApproval = true;
  }

  //check first if element with class has-comments-in-payroll is present on page (only present on payroll page)
  let hasCommentsInPayroll = document.getElementById("comments-exists-in-payroll");
  let payrollHasComments = false;
  if (hasCommentsInPayroll) {
    payrollHasComments = true;
  }

  //set variable to false to hide actions column based on hasCommentsInPayroll and payrollIsSentForApproval
  let hideActionsColumn = false;
  if(payrollHasComments == false && payrollIsSentForApproval == true) {
    hideActionsColumn = true;
  }

 /**
   * Init an array called columns that defines the columns of the DataTable. 
   * Each object in the array represents a single column of the DataTable.
   */
   
  const columns = [
    {
      data: "status",
      className: "small-text",
      render(data) {
        return data
          ? `<span class="text-success">${
              allLangFiles.salary.payroll.updated
            }</span>`
          : `<span class="text-danger">${
              allLangFiles.salary.payroll.not_updated
            }</span>`;
      },
    },
    { 
      data: "name", 
      className: "small-text",
    },
    {
      data: "employment_date",
      className: "small-text",
      render(data) {
        return moment(data).format("DD-MM-YYYY");
      },
    },
    {
      data: "termination",
      className: "small-text",
      render(data) {
        let terminateDate = data ? data['termination_date'] : null;
        if(terminateDate == null) {
          return "";
        } else {
          return moment(terminateDate, 'DD/MM/YYYY').format("DD-MM-YYYY");
        }
      },
    },
    ...editableColumns,
    { data: "actions", visible: hideActionsColumn == true ? false : true}, //added to hide actions column if payroll is sent for approval and there are not comments
    { data: "comment", visible: false}, //added hidden column for comments which is used in exports only.
  ];

  /**
   * Init the column definitions for the DataTable. It creates an array of objects, with each object representing a column and its properties.
   * Logic for coloring the cells if the value is_updated is 1 is added here.
   */
  
  const authUserRole = $('#btn-payroll-authUser').data('auth-user'); //Get the auth user role

  const columnDefs = [
    { targets: "_all", className: "custimze-table" },
    { width: "5%", targets: 0 },
    { width: "5%", targets: 2 },
    ...editableColumns.map((col, index, editableCols) => {
      return {
        width: `${Math.round(80 / editableCols.length)}%`,
        targets: index + 4,
        createdCell: function (td, cellData, rowData, row, col) {
          const payrollFieldId = $(td).find(".payroll-input").data("payroll-field-id");
          //only add color to the updated cells if the user has the role "Payroll" or "SuperAdmin"
          if (payrollFieldId && authUserRole == 'Payroll' || authUserRole == 'super-admin') {
            rowData.payroll_data.forEach((element) => {
              if (element.payroll_data_field_id == payrollFieldId && element.is_updated != 0) {
                $(td).css('background-color', 'LightGreen');
                const input = $(td).find("input");
                $(input).css('background-color', 'LightGreen');
              }
            });
          }
        }
      };
    }),
    { width: "8%", targets: editableColumns.length + 2 },
  ];

  let numericElements = [];

  /**
   * Initialization of the DataTable with the defined columns and column definitions.
   */
  const table = $table.DataTable({
    language: allLangFiles.datatables,
    rowId: "id",
    ajax: {
      url: `/salary/payrolls/load/${selectedPayrollId}`,
      dataSrc: function(json) {
        window.payrollTable = json["data"];

        const payrollData = json["data"];

        calculateTotals(payrollData);

        return json.data;
      },
    },
    order: [[1, "asc"]],
    columns,
    columnDefs,
    scrollX: true,
    scrollY: false,
    autoWidth: false,
    lengthMenu: [[-1], [allLangFiles.datatables.all]],
    initComplete: function(settings, json) {
      table.draw();
    },
    drawCallback() {
      addSelectedCompanyHandler(function(event) {
        const data = event.params.data;

        pjaxRedirect("/salary/payrolls");
      });

      getSummary(selectedPayrollId);

      //logic to remove scrolling on input fields
      $(".payroll-input").each(function(index, el) {
        $(el).css({ "max-width": "95px", "overflow": "hidden" });
        $(el).on('wheel focus', function(e) {
          if (e.type === 'focus') {
            $(this).data('last-value', $(this).val());
          } else if (e.type === 'wheel' && $(this).is(':focus')) {
            e.preventDefault(); // prevent default scrolling behavior
            $(this).blur(); // remove focus from the input element
            if ($(this).val() !== $(this).data('last-value')) {
              e.preventDefault(); // prevent default scrolling behavior
              $(this).blur(); // remove focus from the input element
            }
          } else if (e.type === 'blur') {
            $(this).data('last-value', $(this).val());
          }
        });
        $(el).css({ "max-width": "70px" });
      });
      
      if (numericElements.length > 0) {
        for (let i = 0; i < numericElements.length; i++) {
          numericElements[i].remove();
        }

        numericElements = [];
      }

      const inputs = document.getElementsByClassName("payroll-input");

      for (let i = 0; i < inputs.length; i++) {
        numericElements.push(
          new AutoNumeric(
            document.getElementById(inputs[i].id),
            "commaDecimalCharDotSeparator"
          )
        );
      }

      /**
       * Adds a click event listener to the "Add employee" button.
       * When the button is clicked, the employeeId is retrieved from the data attribute.
       * Confirmation dialog is shown to the user to confirm the action.
       * If the user confirms the action, an AJAX request is sent to the server to add the employee to the payroll.
       */
      $(document)
        .off("click", ".payroll-remove-employee")
        .on("click", ".payroll-remove-employee", function() {
          const employeeId = $('#employeeToRemove').val();
          const url = `/salary/payrolls/${selectedPayrollId}/employees/${employeeId}`;
          const $removeEmployeeFromPayrollModal = $("#modal-remove-employee-from-payroll");

          //only allow showing confirmation modal if an employee has been selected
          if(employeeId != null) {
          
          $.confirm({
            title: allLangFiles.salary.payroll.remove_employee,
            content: allLangFiles.salary.payroll.are_you_sure,
            theme: "supervan",
            columnClass: "col-md-12",
            backgroundDismiss: true,
            buttons: {
              Ja: {
                action: function() {
                  $.ajax(url, {
                    method: "DELETE",
                    success() {
                      window.location.reload();
                      $removeEmployeeFromPayrollModal.modal("hide");
                      toastr.success(allLangFiles.forms.general.success);
                    },
                    error() {
                      toastr.error(allLangFiles.forms.generic_error);
                    },
                  });
                },
                text: allLangFiles["pay-slips"].confirm.yes,
              },
              Remove: {
                action: function() {
                  this.close();
                  $removeEmployeeFromPayrollModal.modal("hide");
                  const $terminateEmployeeModal = $(
                    "#modal-terminate-employee"
                  );
                  const form = $("#form-terminate-employee");
                  const lang = allLangFiles.termination.js;
                  $terminateEmployeeModal.modal("show");

                  const data = $table
                    .DataTable()
                    .row(`#${employeeId}`)
                    .data();
                  const fullName = `${data.first_name} ${data.last_name}`;
                  const title = lang.input_title + fullName;
                  const isNotHourlyAndNotBHonorarium =
                    data.employment_type !==
                      "App\\Model\\Salary\\CustomerHourlyEmployee" &&
                    data.employment_type !==
                      "App\\Model\\Salary\\CustomerBHonorariumReceiverEmployee";
                  const isTerminated = data.termination !== null;

                  $terminateEmployeeModal.find(".modal-title").html(title);

                  form.find("input[name=id]").val(employeeId);

                  moment.locale("da");

                  const termination_date =
                    data.termination === null
                      ? moment().format("D/M/Y")
                      : data.termination.termination_date;

                  $("#termination_date").val(termination_date);

                  if (isNotHourlyAndNotBHonorarium) {
                    $("#notice_date")
                      .parents(".form-group")
                      .removeClass("hidden");
                    $("#days_vacation_period")
                      .parents(".form-group")
                      .removeClass("hidden");

                    var noticeDate =
                      data.termination === null
                        ? moment().format("D/M/Y")
                        : data.termination.notice_date;

                    $("#notice_date").val(noticeDate);
                  } else {
                    $("#notice_date")
                      .parents(".form-group")
                      .addClass("hidden");
                    $("#days_vacation_period")
                      .parents(".form-group")
                      .addClass("hidden");
                  }

                  if (isNotHourlyAndNotBHonorarium && isTerminated) {
                    form
                      .find("input[name=days_vacation_period]")
                      .val(data.termination.days_vacation_period);
                  }

                  if (isTerminated) {
                    $terminateEmployeeModal.find(".btn-cancel").show();
                  } else {
                    $terminateEmployeeModal.find(".btn-cancel").hide();
                  }

                  $terminateEmployeeModal
                    .find(":submit")
                    .off("click")
                    .on("click", function(e) {
                      e.preventDefault();

                      const title = lang.confirm_title + fullName;
                      const confirmMsg = lang.confirm_msg + fullName + ":";
                      const yesTxt = lang.yes;
                      const noTxt = lang.no;

                      //TODO validate fields that are visible

                      $.confirm({
                        title: title,
                        content: confirmMsg,
                        theme: "supervan",
                        columnClass: "col-md-12",
                        backgroundDismiss: true,
                        buttons: {
                          Yes: {
                            text: yesTxt,
                            action: function() {
                              const data = form.serialize();

                              $.ajax({
                                type: "POST",
                                data: data,
                                url: "/employee/terminate/create",
                                success: function(response) {
                                  printResponse(response);

                                  $.ajax(url, {
                                    method: "DELETE",
                                    success() {
                                      $table.DataTable().ajax.reload();
                                      $terminateEmployeeModal.modal("hide");
                                    },
                                  });
                                },
                                error: fnErrorMsg,
                              });
                            },
                          },
                          No: {
                            text: noTxt,
                          },
                        },
                      });
                    });

                  $terminateEmployeeModal
                    .off("hidden.bs.modal")
                    .on("hidden.bs.modal", function() {
                      resetForm(form);
                      $(".additional-termination-fields").html("");
                    });
                },
                text: allLangFiles.salary.payroll.yes_and_remove,
              },
              Nej: {
                text: allLangFiles["pay-slips"].confirm.no,
              },
            },
          });
        } else {
          //show toast if no employee has been selected and the user tries to remove an employee
          toastr.error(allLangFiles.payrolls.edit.no_employee_selected);
        }
        });

      /**
       * Add click event to the add comment button.
       * Shows modal for adding comment to employee data.
       */
      $(document)
        .off("click", ".payroll-add-comment")
        .on("click", ".payroll-add-comment", function() {
          const $modal = $("#modal-add-employee-data-comment");
          $modal.modal("show");

          const value = $(this).data("value");
          const $row = $(this).parents($("tr"));
          const rowData = $table
            .DataTable()
            .row($row)
            .data();
          const employeeId = rowData.id;

          $("#payrollEmployeeCommentEmployeeId").val(employeeId);
          $("#payrollEmployeeComment").val(value);
        });

      if ($table.hasClass("is-approved")) {
        $(
          ".payroll-input, #payrollEmployeeComment, #submitPayrollAddCommentForm"
        ).prop("disabled", true);

        return;
      } else {
        $("#payrollEmployeeComment, #submitPayrollAddCommentForm").prop(
          "disabled",
          false
        );
      }

      /**
       * Add click event to the submit button in the modal for adding comment to employee data.
       */
      $(document)
        .off("click", "#submitPayrollAddCommentForm")
        .on("click", "#submitPayrollAddCommentForm", function() {
          const employeeId = $("#payrollEmployeeCommentEmployeeId").val();
          const comment = $("#payrollEmployeeComment").val();

          $.ajax(`/salary/payrolls/${selectedPayrollId}/add-comment`, {
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({
              employeeId,
              comment,
            }),
            success() {
              const $modal = $("#modal-add-employee-data-comment");
              $modal.modal("hide");
              $('#datatable-payroll').DataTable().ajax.reload(function(){$('#datatable-payroll').DataTable().columns.adjust().draw();});
            },
            error() {
              toastr.error(allLangFiles.forms.generic_error);
            },
          });
        });


      let oldFieldValue = "";  
      let oldFieldId = "";
      let oldEmployeeId = "";
      $(".payroll-input").on("click focus", function() {
        oldFieldId = $(this).data("field-id");
        oldFieldValue = Number($(this).val().replaceAll(".", "").replaceAll(",", "."));
        oldEmployeeId = $(this).data("employeeId");
      });
      
      /**
       * Add event listener that is triggered when a cell is focused out.
       * The code retrieves the id of the input element that triggered the event, and looks up a corresponding object in an array called numericElements that returns the numeric value of the input element.
       * Checks if the value has been changed, and if so, sends an ajax request to the server to update the value in the database.
       */

      let tabKeyPressed = null;
      let clickedElementId = null;

      //Register if tab key is used to navigate between cells in the table, always set to false when not using tab.
      $(document).on('keydown', function (event) {
        tabKeyPressed = event.key === 'Tab';
      });

      // Click event handler to store the clicked element. Used to focus the clicked element after reload.
      $(".payroll-input").off("click").on("click", function (event) {
        clickedElementId = $(this).attr("id");
        tabKeyPressed = false;
      });


      $(".payroll-input")
        .off("focusout")
        .on("focusout", function() {
          const inputId = $(this).attr("id");
          const anElement = numericElements.find(
            (el) => el.domElement.id === inputId 
          );
    
          let fieldValue = anElement.getNumber();
          const fieldId = $(this).data("field-id");
          const fieldName = fieldId.split(":")[0];
          const fieldType = fieldId.split(":")[1];
          const employeeId = Number($(this).data("employee-id"));
          
          const focusedElementId = $(this).attr("id"); // Store the ID of the focused element

          if(fieldValue < 0 ) { 
            toastr.error(allLangFiles.payrolls.no_negative_value);
          }
          
          let dbValue;

          dbValue = fieldValue !== "" ? Number(fieldValue) : null;

          let fieldValueChanged = dbValue != oldFieldValue;
          
          //Check if field value has been changed, if not, do not send ajax request to server
          if(fieldValueChanged) {
            $(this).prop("disabled", true);
            $.ajax(`/salary/payrolls/${selectedPayrollId}/field-change`, {
              method: "POST",
              dataType: "json",
              contentType: "application/json",
              data: JSON.stringify({
                field: fieldName,
                fieldType: fieldType,
                employeeId: employeeId,
                value: dbValue,
              }),
              success: (response) => {
                $(this).prop("disabled", false);
                if (dbValue === null) {
                  $(this).removeClass("payroll-input--filled");
                } else {
                  $(this).addClass("payroll-input--filled");
                }

                //Update the total values in the table footer
                $.ajax(`/salary/payrolls/load/${selectedPayrollId}`, {
                  success: (response) => {
                    calculateTotals(response["data"], true);
                  },
                });

                //Only show pop-up the field has value has been changed
                if (dbValue  !== oldFieldValue && dbValue != 0) {
                  if (response.field === "gage" && employeeId == oldEmployeeId) {
                    showGageModal(response.name, dbValue, employeeId);
                  }
            
                  if (response.field === "lunch_arrangement_monthly") {
                    showLunchArrangementMonthlyModal(response.name, dbValue, employeeId);
                  }

                  if (response.field === "fixed_add_ons_monthly") {
                    showFixedAddOnsMonthlyModal(response.name, dbValue, employeeId);
                  }
                  
                  if (response.field === "hourly_rate" && oldFieldId === "hourly_rate:amount") {
                    showHourlyRateModal(response.name, dbValue, employeeId);
                  }
                }

                //If a field is updated, the table is reloaded to ensure table data is updated
                if (response.isUpdated) {
                  $('#datatable-payroll').DataTable().ajax.reload(function () {
                    $('#datatable-payroll').DataTable().columns.adjust().draw();

                    //When using tab key to navigate between cells, focus the next element in the table after reload.
                    //If tab key is not used, focus the clicked element after reload.
                    if (tabKeyPressed) {
                      const $focusedElement = $("#" + focusedElementId);
                      const $nextTd = $focusedElement.closest("td").nextAll("td:has(:input, button)").first();

                      if ($nextTd.length > 0) {
                        const $nextElement = $nextTd.find(":input, button").first();

                        if ($nextElement.is(":button")) {
                          $nextElement.focus();
                        } else {
                          const nextElementId = $nextElement.attr("id");
                          $("#" + nextElementId).focus();
                        }
                      }
                    } else {
                      $("#" + clickedElementId).focus();
                    }
                  });
                }

                // If amount should be updated update it
                if (response.amountUpdated) {
                  const amountSelector = `input.payroll-input[data-field-id="${fieldName}:amount"][data-employee-id="${employeeId}"]`;
                  const anElement = numericElements.find(
                    (el) => el.domElement.id === $(amountSelector).attr("id")
                  );
          
                  if (response.amount !== null) {
                    anElement.set(response.amount.toFixed(2));
                  } else {
                    $(amountSelector).val("");
                    anElement.clear();
                  }
                }
              },
              error() {
                // Reload the DataTable if something went wrong
                $table.DataTable().ajax.reload();
              },
            });
          }
        });
    },
  });

  $table.css({ width: "100% !important" });
  redesignDataTablesHeader(tableId);

  loadAddEmployeeToPayrollButton();
  loadRemoveEmployeeFromPayrollButton();
};



function loadAddEmployeeToPayrollButton(){
  //disable button if payroll has been approved
  if ($('#btn-add-employees-to-payroll').hasClass("is-approved")) {
    $('#btn-add-employees-to-payroll').prop("disabled", true);

    return;
  } else {
    $('#btn-add-employees-to-payroll').prop("disabled", false);
  }
  
  $('#btn-add-employees-to-payroll').off().on('click', function() {
      const $modal = $('#modal-add-employee-to-payroll');
      $modal.modal("show");
      const payrollId = $(this).data("payroll-id");
      $('.add-employee-to-payroll').select2({
        placeholder: allLangFiles.payrolls.select_employee,
        allowClear: true,
      });

      $('#submitAddEmployeeToPayrollForm').off().on('click', function() {
        const employeeId = $('#employeeToAdd').val();

        $.ajax(`/salary/payrolls/${payrollId}/add-employee/${employeeId}`, {
          method: "POST",
          contentType: "application/json",
          dataType: "json",
          success: function(response){
            const $modal = $('#modal-add-employee-to-payroll');
            $modal.modal("hide");
            response.success !== undefined && response.success != "" ? toastr.success(response.success) : toastr.error(response.error);
            if(response.success !== undefined && response.success != ""){
              window.location.reload();
            }
          },
          error: function(){
            if(employeeId == null || employeeId == ""){
              toastr.error(allLangFiles.payrolls.edit.select_employee_to_add);
            }
            toastr.error(allLangFiles.forms.generic_error);
            $('#datatable-payroll').DataTable().ajax.reload(function(){$('#datatable-payroll').DataTable().columns.adjust().draw();});
          }
        });
       });
  });
}

function loadRemoveEmployeeFromPayrollButton(){
  //disable button if payroll has been approved
  if ($('#btn-remove-employees-from-payroll').hasClass("is-approved")) {
    $('#btn-remove-employees-from-payroll').prop("disabled", true);

    return;
  } else {
    $('#btn-remove-employees-from-payroll').prop("disabled", false);
  }
  
  $('#btn-remove-employees-from-payroll').off().on('click', function() {
    const $modal = $('#modal-remove-employee-from-payroll');
    $modal.modal("show");
    $('.remove-employee-from-payroll').select2();
  });
}

window.calculateTotals = (data, update = false) => {
  const tableId = "#datatable-payroll";
  const $table = $(tableId);

  let totals = {};

  const editableColumns = $table
    .find($("th[data-editable-column]"))
    .toArray()
    .map((el) => {
      let type = $(el)
        .data("editable-column")
        .replaceAll(":", "_");
      totals[type] = 0;
    });

  data.forEach((item) => {
    Object.keys(totals).forEach((key) => {
      totals[key] += item[key];
    });
  });

  Object.keys(totals).forEach((item) => {
    if (update) {
      updateInputField(`.${item}-total`, totals[item]);
    } else {
      renderInputField(`.${item}-total`, totals[item]);
    }
  });
};

window.renderInputField = (cell, total) => {
  let classes = "payroll-input payroll-input--filled";

  $(cell).html(`
    <input
        type="text"
        id="${cell.replaceAll(".", "")}"
        value="${thousandSeparator(total)}"
        class="${classes}"
        readonly
        disabled="disabled"
    />
    
    <span style="position: absolute; opacity:0;">
        ${thousandSeparator(total)}
    </span>
`);
};

window.updateInputField = (cell, total) => {
  $(`${cell} .payroll-input`).attr("value", thousandSeparator(total));
  $(`${cell} span`).html(total);
};

window.thousandSeparator = (value) => {
  return value.toLocaleString("da-DK", { minimumFractionDigits: 2 });
};

//Pop-up asking if the salary should be updated on master data too
window.showGageModal = (name, value, id) => {
  const modal = $("#gage-modal");
  modal.find("#updateButton").attr("data-id", id);
  modal.find(".gage-modal-name").html(name + ",");
  modal.fadeIn();
};

//Pop-up asking if the lunch arrangement should be updated on master data too
window.showLunchArrangementMonthlyModal = (name, value, id) => {
  const modal = $("#lunch-arrangement-modal");
  modal.find("#updateLunchArrangementButton").attr("data-id", id);
  modal.find(".lunch-arrangement-modal-name").html(name + ",");
  modal.fadeIn();
};


//Pop-up asking if the fixed add ons should be updated on master data too
window.showFixedAddOnsMonthlyModal = (name, value, id) => {
  console.log('showFixedAddOnsMonthlyModal');

  const modal = $("#fixed-add-ons-modal");
  modal.find("#updateFixedAddOnsButton").attr("data-id", id);
  modal.find(".fixed-add-ons-modal-name").html(name + ",");
  modal.fadeIn();
};

//Call to function updating fixed add ons monthly amount in DB
window.updateEmployeeFixedAddOnsData = () => {
  const table = $(table).DataTable();
  const button = $("#updateFixedAddOnsButton");
  const id = button.attr("data-id");
  const newValue = $("#payrollInput-fixed_add_ons_monthly_amount-" + id)
    .val()
    .replaceAll(".", "")
    .replaceAll(",", ".");
  
  const data = {
    fixedAddOnsMonthly: newValue,
  };

  $.ajax(`/employee/${id}/fixedAddOns/update`, {
    method: "POST",
    data,
    success: (response) => {
      printResponse(response);
      $("#fixed-add-ons-modal").fadeOut();
    },
  });
};

//function to close fixed add ons modal
window.closeFixedAddOnsModal = () => {
  const modal = $("#fixed-add-ons-modal");
  modal.fadeOut();
};

//Pop-up asking if hourly rate should be updayed on master data too
window.showHourlyRateModal = (name, value, id) => {
  const modal = $("#hourly-rate-modal");
  modal.find("#updateHourlyRateButton").attr("data-id", id);
  modal.find(".hourly-rate-modal-name").html(name + ",");
  modal.fadeIn();
};

//Function to update hourly rate on master data in DB
window.updateHourlyRateData = () => {
  const table = $(table).DataTable();
  const button = $("#updateHourlyRateButton");
  const id = button.attr("data-id");
  const newValue = $("#payrollInput-hourly_rate_amount-" + id)
    .val()
    .replaceAll(".", "")
    .replaceAll(",", ".");

    const data = {
      hourlyRate: newValue,
    };

    $.ajax(`/employee/${id}/hourlyRate/update`, {
      method: "POST",
      data,
      success: (response) => {
        printResponse(response);
        $("#hourly-rate-modal").fadeOut();
      },
    });
}

window.closeHourlyRateModal = () => {
  const modal = $("#hourly-rate-modal");
  modal.fadeOut();
};


//Call to function updating lunch arrangement in DB
window.updateEmployeeLunchArrangementData = () => {
  const table = $(table).DataTable();
  const button = $("#updateLunchArrangementButton");
  const id = button.attr("data-id");
  const newValue = $("#payrollInput-lunch_arrangement_monthly_amount-" + id)
    .val()
    .replaceAll(".", "")
    .replaceAll(",", ".");
  
  const data = {
    lunchArrangementMonthly: newValue,
  };

  $.ajax(`/employee/${id}/lunchArrangement/update`, {
    method: "POST",
    data,
    success: (response) => {
      printResponse(response);
      $("#lunch-arrangement-modal").fadeOut();
    },
  });
};

window.closeLunchArrangementModal = () => {
  const modal = $("#lunch-arrangement-modal");
  modal.fadeOut();
};

window.updateEmployeeData = () => {
  const button = $("#updateButton");
  const id = button.attr("data-id");
  const newValue = $("#payrollInput-gage_amount-" + id)
    .val()
    .replaceAll(".", "")
    .replaceAll(",", ".");

  const data = {
    salary: newValue,
  };

  $.ajax(`/employee/${id}/salary/update`, {
    method: "POST",
    data,
    success: (response) => {
      printResponse(response);
      $("#gage-modal").fadeOut();
    },
  });
};

window.closeGageModal = () => {
  const modal = $("#gage-modal");
  modal.fadeOut();
};